import { AuthError } from "@azure/msal-browser";
import { msalInstance } from "../App";
import ky from "./ky";

import { acquireAccessToken } from "./msal";

const getApi = (accessToken: string) => {
  return ky.extend({
    timeout: 60000,
    headers: {
      Authorization: "Bearer " + accessToken,
    },
    // hooks: {
    //   beforeRequest: [
    //     (request) => {
    //       (request?.headers as any).set(
    //         "Authorization",
    //         "Bearer " + acquireAccessToken()
    //       );
    //     },
    //   ],
    // },
  });
};
const parse = (res: string) => JSON.parse(res, dateTimeReviver);

/**
 * サーバーへGETリクエストを送信
 * @param path
 * @param query
 */
export async function get<T>(
  path: string,
  query?: Record<string, string>
): Promise<T> {
  try {
    const accessToken = await acquireAccessToken();
    const p = new URLSearchParams(query);
    const res = await getApi(accessToken).get(path, { searchParams: p }).text();
    return parse(res);
  } catch (error) {
    if (
      error instanceof AuthError &&
      error.errorMessage.includes("AADSTS50058")
    ) {
      // @ts-ignore
      msalInstance.loginRedirect();
      throw error;
    } else {
      throw error;
    }
  }
}

/**
 * サーバーへPOSTリクエストを送信
 * @param path
 * @param body
 */
export async function post<T>(path: string, body: object): Promise<T> {
  return update("POST", path, body);
}

/**
 * サーバーへPUTリクエストを送信
 * @param path
 * @param body
 */
export async function put<T>(path: string, body: object): Promise<T> {
  return update("PUT", path, body);
}

/**
 * サーバーへDELETEリクエストを送信
 * @param path
 */
export async function deleteRequest<T>(path: string): Promise<T> {
  return update("DELETE", path);
}

async function update<T>(
  method: "POST" | "PUT" | "DELETE",
  path: string,
  body?: object
): Promise<T> {
  // FIXME
  // https://qiita.com/Hiroki_M/items/e66620df1f419e6b526b
  const original = Date.prototype.toJSON;
  let res: string;

  try {
    Date.prototype.toJSON = function () {
      return (
        this.getFullYear() +
        "-" +
        ("0" + (this.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + this.getDate()).slice(-2) +
        "T" +
        ("0" + this.getHours()).slice(-2) +
        ":" +
        ("0" + this.getMinutes()).slice(-2) +
        ":" +
        ("0" + this.getSeconds()).slice(-2) +
        "Z"
      );
    };

    const accessToken = await acquireAccessToken();

    switch (method) {
      case "POST":
        res = await getApi(accessToken).post(path, { json: body }).text();
        break;
      case "PUT":
        res = await getApi(accessToken).put(path, { json: body }).text();
        break;
      case "DELETE":
        res = await getApi(accessToken).delete(path).text();
        break;
      default:
        throw Error("Invalid HTTP Method!");
    }
  } finally {
    // FIXME
    Date.prototype.toJSON = original;
  }

  return res ? parse(res) : {};
}

// https://stackoverflow.com/a/14509447
// https://qiita.com/kidatti/items/272eb962b5e6025fc51e
// https://www.regextester.com/94925
const dateTimeReviver = (key: any, value: any) => {
  if (typeof value === "string") {
    const r =
      /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(\\.[0-9]+)?(Z)?$/.exec(
        value
      );
    if (r) {
      return new Date(value);
    }
  }
  return value;
};
